import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { JYoguiSharedModule } from '../../shared';

import {
    ReservationPriorityService,
    ReservationPriorityPopupService,
    ReservationPriorityComponent,
    ReservationPriorityDetailComponent,
    ReservationPriorityDialogComponent,
    ReservationPriorityPopupComponent,
    ReservationPriorityDeletePopupComponent,
    ReservationPriorityDeleteDialogComponent,
    reservationPriorityRoute,
    reservationPriorityPopupRoute,
    ReservationPriorityResolvePagingParams,
} from './';

let ENTITY_STATES = [
    ...reservationPriorityRoute,
    ...reservationPriorityPopupRoute,
];

@NgModule({
    imports: [
        JYoguiSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        ReservationPriorityComponent,
        ReservationPriorityDetailComponent,
        ReservationPriorityDialogComponent,
        ReservationPriorityDeleteDialogComponent,
        ReservationPriorityPopupComponent,
        ReservationPriorityDeletePopupComponent,
    ],
    entryComponents: [
        ReservationPriorityComponent,
        ReservationPriorityDialogComponent,
        ReservationPriorityPopupComponent,
        ReservationPriorityDeleteDialogComponent,
        ReservationPriorityDeletePopupComponent,
    ],
    providers: [
        ReservationPriorityService,
        ReservationPriorityPopupService,
        ReservationPriorityResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JYoguiReservationPriorityModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/reservation-priority/reservation-priority.module.ts